/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookInstanceDataSchema = z.object({
	idInstance: z.int(),
});
